/**
 * Browser utility functions
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
export const updateHistory = (path, isReplace = false) => {
  if (!isReplace) {
    window.history.pushState(null, null, path)
  } else {
    window.history.replaceState(null, null, path)
  }
}

export const logError = (message, error) => {
  const xhr = new XMLHttpRequest()
  xhr.open('POST', '/log', true)
  xhr.setRequestHeader('Content-Type', 'application/json')

  const body = {
    message,
    stack: error ? error.stack : ''
  }

  xhr.send(JSON.stringify(body))
}

export const BrowserLogger = () => {
  if (!__DEV__) {
  /**
   * Capture and report errors on the browser to our server logger.
   * @param  {String} message      error message
   * @param  {String} url          URL of the script where the error was raised
   * @param  {String} lineNumber   Line number where error was raised
   * @param  {String} columnNumber Column number for the line where the error occurred
   * @param  {Object} error         Error object
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onerror}
   */
    window.onerror = (message = '', url, lineNumber, columnNumber, error) => {
      const isScriptError = (message.toLowerCase().indexOf('script error') > -1)

      // In the event that the error comes from an external script, we ignore the error to prevent messy warnings
      // See: https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onerror#notes
      if (!isScriptError) {
        const lineNumStr = lineNumber ? `[LineNo: ${lineNumber}]` : ''
        const errorMsg = `Javascript Error. Url: ${url}; Line Number: ${lineNumStr}; Message: ${message}`

        logError(errorMsg, error)
      }
    }
  }
}
